import { IVariation } from '~/lib/data-contract';

export const sortColorVariants = (variants: IVariation[]) => {
	return variants.sort((a, b) => (a.sku > b.sku ? 1 : -1));
};
